export function convertToDoubleDigits(n: any) {
  n = String(n);
  if (n.length === 1) n = "0" + n;
  return n;
}

export function getYearMonthDay(value: string) {
  return (
    new Date(value).getFullYear() +
    "-" +
    convertToDoubleDigits(new Date(value).getMonth() + 1) +
    "-" +
    new Date(value).getDate()
  );
}

export function getHourMinute(value: string) {
  return (
    new Date(value).getHours() +
    ":" +
    convertToDoubleDigits(new Date(value).getMinutes())
  );
}
